/**
 * @generated SignedSource<<3f9b4ccfbe5f357a52183a7a22882fc9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AgenticWorkerRunState = "RUNNING" | "STOPPED" | "NOTHING_FOUND" | "PRODUCED" | "FAILED" | "NOT_STARTED" | "%future added value";
export type StopAgenticWorkerRunInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type StopAgenticWorkerRunMutation$variables = {
  input: StopAgenticWorkerRunInput;
};
export type StopAgenticWorkerRunMutation$data = {
  readonly stopAgenticWorkerRun: {
    readonly run: {
      readonly id: string;
      readonly state: AgenticWorkerRunState;
    } | null;
  } | null;
};
export type StopAgenticWorkerRunMutation = {
  variables: StopAgenticWorkerRunMutation$variables;
  response: StopAgenticWorkerRunMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StopAgenticWorkerRunPayload",
    "kind": "LinkedField",
    "name": "stopAgenticWorkerRun",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AgenticWorkerRun",
        "kind": "LinkedField",
        "name": "run",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StopAgenticWorkerRunMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StopAgenticWorkerRunMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "baa849793a900cc4cc00406236414bf3",
    "id": null,
    "metadata": {},
    "name": "StopAgenticWorkerRunMutation",
    "operationKind": "mutation",
    "text": "mutation StopAgenticWorkerRunMutation(\n  $input: StopAgenticWorkerRunInput!\n) {\n  stopAgenticWorkerRun(input: $input) {\n    run {\n      id\n      state\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d5e7d1ff0bc635bcd544c0a0fbbd8a8f";

export default node;
